import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const buildTitle = (head, action) => {
  if (head && action) {
    return `${head} - ${action}`;
  }
  return head || action || null;
};

/**
 * Sets `document.title` using the currently loaded record. Must be rendered
 * inside a react-admin view that provides a record context (Show, Edit, …).
 *
 * @param {(record: object) => string} format Called with the record to produce
 * the display name. Return a falsy value to fall back to `fallback`.
 * @param {string} [fallback] Optional name shown until the record is loaded
 * or when `format` returns a falsy value.
 * @param {string} [action] Optional trailing action label, e.g. "Édition".
 */
const RecordPageTitle = ({ format, fallback, action }) => {
  const record = useRecordContext();
  const name = record ? format(record) : null;
  const head = name || fallback || null;

  useDocumentTitle(buildTitle(head, action));

  return null;
};

RecordPageTitle.propTypes = {
  format: PropTypes.func.isRequired,
  fallback: PropTypes.string,
  action: PropTypes.string,
};

RecordPageTitle.defaultProps = {
  fallback: undefined,
  action: undefined,
};

export default RecordPageTitle;
